import {api} from "@/api/base"

/**
 * 查询字体列表
 * @param data
 */
export const getFontList = (data) => {
    return api.post('/api/font/list', data)
}

/**
 * 图片上传
 * @param data
 */
export const upload = (data) => {
    return api.post('/api/design/upload', data)
}

/**
 * 图片上传
 * @param data
 */
export const init = (data) => {
    return api.post('/api/design/init', data)
}

/**
 * 完成
 * @param data
 */
export const finish = (data) => {
    return api.post('/api/design/finish', data)
}

/**
 * 获取素材库
 * @param data
 * @returns {*}
 */
export const getClipartList = (data) => {
    return api.get("/api/design/clipart", data);
}

/**
 * 获取用户上传的素材
 * @param data
 * @returns {*}
 */
export const getUserImages = (data) => {
    return api.post("/api/design/get-user-images", data);
}

/**
 * 删除用户上传的素材
 * @param data
 * @returns {*}
 */
export const deleteUserImage = (data) => {
    return api.post("/api/design/delete-user-image", data);
}